import AppEnvironment from '../../../components/enums/appEnvironment.enum';
import { isAdminTeceo } from '../../context/ApplicationContext/applicationContext.utils';
import { ResourceType } from '../../users/ability.types';
import { VisibilityContext, VisibilityRule } from '../types/featureVisibility.types';

export const and =
  (...rules: VisibilityRule[]): VisibilityRule =>
  (ctx) =>
    rules.every((rule) => rule(ctx));

export const or =
  (...rules: VisibilityRule[]): VisibilityRule =>
  (ctx) =>
    rules.some((rule) => rule(ctx));

export const not =
  (rule: VisibilityRule): VisibilityRule =>
  (ctx) =>
    !rule(ctx);

export const isNeverVisible: VisibilityRule = () => false;

export const isNotOfflineMode: VisibilityRule = ({ isOfflineMode }) => !isOfflineMode;

export const isBrandEnv: VisibilityRule = ({ appEnvironment }) =>
  appEnvironment === AppEnvironment.BRAND;
export const isStoreEnv: VisibilityRule = ({ appEnvironment }) =>
  appEnvironment === AppEnvironment.STORE;
export const isNotStoreEnv: VisibilityRule = ({ appEnvironment }) =>
  appEnvironment !== AppEnvironment.STORE;

export const isBrand: VisibilityRule = ({ appContext }) => appContext.isBrand;
export const isStore: VisibilityRule = ({ appContext }) => appContext.isStore;
export const isNotStore: VisibilityRule = ({ appContext }) => !appContext.isStore;
export const isAdminBrand: VisibilityRule = ({ appContext }) => appContext.isAdminBrand;

export const hasIntegrations: VisibilityRule = ({ appContext }) =>
  (appContext.integrations ?? []).length > 0;

export const isTeceoAdmin: VisibilityRule = () => isAdminTeceo();

export const canMenu =
  (resource: ResourceType): VisibilityRule =>
  ({ ability }) =>
    ability.can('menu', resource);

export const canUpdate =
  (resource: ResourceType): VisibilityRule =>
  ({ ability }) =>
    ability.can('update', resource);

export const canCreate =
  (resource: ResourceType): VisibilityRule =>
  ({ ability }) =>
    ability.can('create', resource);

export const canRead =
  (resource: ResourceType): VisibilityRule =>
  ({ ability }) =>
    ability.can('read', resource);

export const hasFlag =
  (flag: keyof VisibilityContext['featureFlags']): VisibilityRule =>
  ({ featureFlags }) =>
    Boolean(featureFlags[flag]);
